/* TimbA — "Send your drawing" enquiry page.
   Used by: sections/timba-get-a-spec.liquid
   Built 7 September 2026 for Build 1 of Tina's lead-engine brief.

   A classic script, loaded with defer. No framework, no build step, nothing
   imported. It does five things:

     1. collects the files, checks them in the browser and shows them back
     2. works out where the enquiry came from, so every lead has a source
     3. posts the form to the enquiry service as multipart/form-data
     4. reports upload progress, because a 20 MB drawing on a site's 4G
        takes long enough that a silent button looks broken
     5. fires one conversion event, into whichever analytics the page has

   The browser-side checks are a courtesy, not a control. The service on
   app.timbasystems.com re-checks the size, the count and the magic bytes of
   every file and refuses anything it does not like. Nothing here is trusted
   by it and nothing here should be treated as security. */

(function () {
  'use strict';

  var root = document.getElementById('tgs-root');
  if (!root) return;

  var cfg = { endpoint: '', maxFiles: 3, maxFileMb: 25, maxTotalMb: 30, accept: '' };
  try {
    var cfgEl = document.getElementById('tgs-config');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent);
  } catch (e) { /* keep the defaults, the service enforces the real limits */ }

  var form = document.getElementById('tgs-form');
  var card = document.getElementById('tgs-card');
  var done = document.getElementById('tgs-done');
  var doneRef = document.getElementById('tgs-done-ref');
  var doneFiles = document.getElementById('tgs-done-files');
  var fail = document.getElementById('tgs-fail');
  var failMsg = document.getElementById('tgs-fail-msg');
  var send = document.getElementById('tgs-send');
  var bar = document.getElementById('tgs-bar');
  var barFill = bar ? bar.querySelector('i') : null;

  var drop = document.getElementById('tgs-drop');
  var picker = document.getElementById('tgs-file-input');
  var fileList = document.getElementById('tgs-files');

  if (!form) return;

  /* ── the files the customer has chosen ──────────────────────────────
     Held here rather than on the <input>, because a file input cannot be
     added to: choosing a second time replaces the first choice. People
     photograph a drawing in three parts and pick them one at a time. */

  var chosen = [];

  function mb(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
    return (bytes / 1024 / 1024).toFixed(1) + ' MB';
  }

  function ext(name) {
    var i = String(name).lastIndexOf('.');
    return i > -1 ? name.slice(i + 1).toUpperCase().slice(0, 4) : 'FILE';
  }

  function totalBytes() {
    var t = 0;
    for (var i = 0; i < chosen.length; i++) t += chosen[i].file.size;
    return t;
  }

  /* D2 (8 Sep 2026). The file problems used to be worked out once, when a file
     was added, and then never again. Add 20 MB and then 15 MB against a 30 MB
     limit and the second is marked over the total, correctly. Remove the 20 MB
     one and the 15 MB file is now perfectly fine, but it kept the old red mark
     and the send button kept refusing, with a message about a file that was no
     longer there. The only way out was to remove everything and start again.

     Every file is now judged against the current set, every time the list is
     drawn and once more immediately before sending. The running total counts
     only the files that are themselves acceptable, so one oversized file does
     not cascade into marking everything after it as over the limit too. */
  function revalidate() {
    var running = 0;
    var perFile = cfg.maxFileMb * 1024 * 1024;
    var total = cfg.maxTotalMb * 1024 * 1024;
    chosen.forEach(function (entry) {
      var size = entry.file.size;
      var problem = null;
      if (size === 0) {
        problem = 'This file is empty';
      } else if (size > perFile) {
        problem = 'Too big, the limit is ' + cfg.maxFileMb + ' MB per file';
      } else if (running + size > total) {
        problem = 'Over the ' + cfg.maxTotalMb + ' MB total';
      }
      if (!problem) running += size;
      entry.problem = problem;
    });
    return running;
  }

  function paintFiles() {
    if (!fileList) return;
    revalidate();
    fileList.innerHTML = '';
    chosen.forEach(function (entry, idx) {
      var li = document.createElement('li');
      li.className = 'tgs-file' + (entry.problem ? ' tgs-bad' : '');

      var ic = document.createElement('span');
      ic.className = 'tgs-file-ic';
      ic.textContent = ext(entry.file.name);

      var nm = document.createElement('span');
      nm.className = 'tgs-file-nm';
      /* textContent, never innerHTML: the file name comes from the
         customer's device and can contain anything. */
      nm.textContent = entry.file.name;
      var sub = document.createElement('small');
      sub.textContent = entry.problem ? entry.problem : mb(entry.file.size);
      nm.appendChild(sub);

      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'tgs-file-rm';
      rm.setAttribute('aria-label', 'Remove ' + entry.file.name);
      rm.textContent = '×';
      rm.addEventListener('click', function () {
        chosen.splice(idx, 1);
        paintFiles();
      });

      li.appendChild(ic);
      li.appendChild(nm);
      li.appendChild(rm);
      fileList.appendChild(li);
    });

    /* D3: the combined limit is the one that actually blocks the send, and the
       upload note never mentioned it: it says three files and 25 MB each, which
       are the other two limits. Rather than write the number into the copy,
       which is a theme setting and Nad's to word, the page now shows where the
       customer actually is. A figure that moves as they add files is more use
       than a sentence, and it needs no wording decision from anyone. */
    if (chosen.length) {
      var used = 0;
      chosen.forEach(function (e) { if (!e.problem) used += e.file.size; });
      var cap = cfg.maxTotalMb * 1024 * 1024;
      var line = document.createElement('li');
      line.className = 'tgs-file-total' + (used > cap * 0.85 ? ' tgs-file-total--near' : '');
      line.textContent = mb(used) + ' of ' + cfg.maxTotalMb + ' MB used, '
        + chosen.length + ' of ' + cfg.maxFiles + ' files';
      fileList.appendChild(line);
    }
  }

  function addFiles(list) {
    for (var i = 0; i < list.length; i++) {
      if (chosen.length >= cfg.maxFiles) {
        flag('You can send ' + cfg.maxFiles + ' files here. Email anything else to info@timbasystems.com and we will match it up.');
        break;
      }
      // D2: no judgement here any more. Adding is just adding; revalidate()
      // decides what is acceptable, against the whole set, at paint time.
      chosen.push({ file: list[i], problem: null });
    }
    paintFiles();
  }

  if (drop && picker) {
    drop.addEventListener('click', function () { picker.click(); });
    drop.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); picker.click(); }
    });
    picker.addEventListener('change', function () {
      addFiles(picker.files);
      /* Clear it, so choosing the same file again still fires a change. */
      picker.value = '';
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('tgs-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('tgs-over'); });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
    });
  }

  /* ── where did this enquiry come from ───────────────────────────────
     Three separate answers, all recorded, because they answer different
     questions:
       source   — the page on our site they were reading when they clicked.
                  Set by the CTA snippet as ?from=/products/whatever.
                  Tells us which page earns enquiries.
       utm      — the campaign that first brought them to the site in this
                  visit. Stashed on arrival by the CTA snippet, because the
                  parameters are on the landing page and are long gone by
                  the time they reach this form.
       referrer — whatever sent them to the site. Google, LinkedIn, direct. */

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) { return ''; }
  }

  function stashed(key) {
    try { return window.sessionStorage.getItem(key) || ''; } catch (e) { return ''; }
  }

  function origin() {
    var src = param('from');
    if (src) return src;
    /* No ?from=, so they arrived some other way. If the previous page was
       ours, use its path. If it was not, this is a direct landing. */
    try {
      if (document.referrer) {
        var u = new URL(document.referrer);
        if (u.host === window.location.host) return u.pathname;
      }
    } catch (e) { /* fall through */ }
    return 'direct';
  }

  /* ── validation ─────────────────────────────────────────────────────
     Only the two things the service also insists on: a name and an email
     that looks like one. Everything else is optional on purpose. A short
     form that a busy person finishes beats a complete one they abandon,
     and we can ask for the rest when we reply. */

  function fieldError(id, message) {
    var input = document.getElementById(id);
    var slot = document.getElementById(id + '-err');
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (slot) {
      slot.textContent = message || '';
      slot.classList.toggle('tgs-on', !!message);
    }
    return !message;
  }

  function validate() {
    var ok = true;
    var name = (document.getElementById('tgs-name') || {}).value || '';
    var email = (document.getElementById('tgs-email') || {}).value || '';

    if (!name.trim()) ok = fieldError('tgs-name', 'Please tell us your name.') && ok;
    else fieldError('tgs-name', '');

    /* Deliberately loose. Something@something.something is as far as a
       browser should go: real addresses break every stricter rule anyone
       has ever written, and the reply bouncing is the real test. */
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      ok = fieldError('tgs-email', 'We reply by email, so we need a working address.') && ok;
    } else {
      fieldError('tgs-email', '');
    }

    if (!ok) {
      var firstBad = form.querySelector('[aria-invalid="true"]');
      if (firstBad) {
        firstBad.focus();
        if (firstBad.scrollIntoView) firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
    return ok;
  }

  function flag(message) {
    if (!fail) return;
    failMsg.textContent = message;
    fail.classList.add('tgs-on');
    if (fail.scrollIntoView) fail.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function unflag() {
    if (fail) fail.classList.remove('tgs-on');
  }

  /* ── the conversion event ───────────────────────────────────────────
     Fired into whatever this page actually has. We do not load an
     analytics library and we do not assume one: each call is guarded, so
     a store with GA4 gets the GA4 event, a store with GTM gets the
     dataLayer push, and a store with neither is not broken by trying.
     generate_lead is GA4's own recommended event name, so it appears in
     the standard reports without anyone configuring anything. */

  function conversion(rec) {
    var payload = {
      enquiry_id: rec.id,
      source: rec.source,
      project_type: rec.project_type,
      files: rec.files
    };
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', payload);
      }
    } catch (e) { /* analytics must never break the confirmation */ }
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: 'generate_lead' }, payload));
      }
    } catch (e) { /* as above */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('timba_enquiry_submitted', payload);
      }
    } catch (e) { /* as above */ }
    try {
      window.dispatchEvent(new CustomEvent('timba:enquiry', { detail: payload }));
    } catch (e) { /* as above */ }
  }

  /* ── submit ─────────────────────────────────────────────────────────
     XMLHttpRequest rather than fetch, for one reason: fetch cannot report
     how far through an upload it is. On a phone on a building site a
     20 MB drawing takes a while, and a button that just sits there is a
     button people press again. */

  var sending = false;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    unflag();
    if (!validate()) return;

    // D2: judged one last time against the set as it stands right now, in case
    // anything changed between the last paint and this click.
    revalidate();
    var bad = chosen.filter(function (c) { return c.problem; });
    if (bad.length) {
      flag('Remove the file marked in red, then send. ' + bad[0].problem + '.');
      return;
    }

    var fd = new FormData();
    ['name', 'company', 'email', 'phone', 'postcode', 'project_type', 'timeline', 'message', 'website'].forEach(function (key) {
      var el = document.getElementById('tgs-' + key);
      if (el) fd.append(key, el.value);
    });
    fd.append('source', origin());
    fd.append('utm', param('utm_source') ? window.location.search.replace(/^\?/, '') : stashed('timba_utm'));
    fd.append('referrer', stashed('timba_ref') || document.referrer || '');
    chosen.forEach(function (c) { fd.append('files', c.file, c.file.name); });

    sending = true;
    send.disabled = true;
    var label = send.textContent;
    send.textContent = 'Sending…';
    if (bar) bar.classList.add('tgs-on');

    var xhr = new XMLHttpRequest();
    xhr.open('POST', cfg.endpoint, true);
    xhr.timeout = 180000;

    xhr.upload.addEventListener('progress', function (ev) {
      if (!barFill || !ev.lengthComputable) return;
      var pct = Math.round((ev.loaded / ev.total) * 100);
      barFill.style.width = pct + '%';
      if (pct >= 100) send.textContent = 'Almost there…';
    });

    function recover(message) {
      sending = false;
      send.disabled = false;
      send.textContent = label;
      if (bar) bar.classList.remove('tgs-on');
      if (barFill) barFill.style.width = '0';
      flag(message);
    }

    xhr.addEventListener('load', function () {
      var body = {};
      try { body = JSON.parse(xhr.responseText); } catch (e) { /* handled below */ }

      if (xhr.status === 200 && body.ok) {
        if (card) card.style.display = 'none';
        if (done) done.classList.add('tgs-on');
        if (doneRef && body.id) doneRef.textContent = body.id;
        var kept = typeof body.files_accepted === 'number' ? body.files_accepted : 0;
        var refused = (body.files_rejected || []).length;
        if (doneFiles) {
          if (refused) {
            doneFiles.textContent = kept + ' of ' + (kept + refused) +
              ' files came through. We could not read the rest, so please email them to info@timbasystems.com.';
          } else if (kept) {
            doneFiles.textContent = kept === 1 ? 'Your drawing is with it.' : 'All ' + kept + ' files are with it.';
          } else {
            doneFiles.textContent = '';
          }
        }
        conversion({
          id: body.id,
          source: origin(),
          project_type: (document.getElementById('tgs-project_type') || {}).value || '',
          files: kept
        });
        if (done && done.scrollIntoView) done.scrollIntoView({ block: 'start', behavior: 'smooth' });
        return;
      }

      if (xhr.status === 413) {
        recover('That was too big to send. The limit is ' + cfg.maxTotalMb + ' MB in total. Send the drawing on its own, or email it to info@timbasystems.com.');
      } else if (xhr.status === 429) {
        recover('That is several enquiries in a few minutes. Give it ten minutes, or call 07312 157434 if it is urgent.');
      } else if (xhr.status === 400) {
        recover(body.error || 'Something in the form was not accepted. Check your name and email address.');
      } else {
        recover('We could not send that just now. Please try again, or email info@timbasystems.com and we will pick it up.');
      }
    });

    xhr.addEventListener('error', function () {
      recover('That did not reach us, which usually means the connection dropped. Try again, or email info@timbasystems.com.');
    });
    xhr.addEventListener('timeout', function () {
      recover('That took too long to upload. On a weak signal, try sending the form without the drawing and email it to info@timbasystems.com.');
    });

    xhr.send(fd);
  });
})();
